import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteGeneralConfigurationSurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Project General Configuration surface. This component will
 * take care of styling your component so it looks good in the **Project configuration > General** section
 * of the Netlify UI.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteGeneralConfiguration
 * @example
 * ```tsx
 * import { SiteGeneralConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <SiteGeneralConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </SiteGeneralConfigurationSurface>
 * ```
 */
export const SiteGeneralConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: SiteGeneralConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteGeneralConfiguration}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
